<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <!-- <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li> -->
              <li class="breadcrumb-item active">Merchant</li>
            </ol>
          </div>
          <h4 class="page-title">Merchant Management</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Merchants</h4>
          <p class="sub-header">
            Create and Edit merchants for your current participant
          </p>

          <div class="row">
            <div class="col-9">
              <div class="form-check" *ngIf="isAdmin">
                <input mdbCheckbox class="form-check-input" type="checkbox" [(ngModel)]="globalSearch" (change)="setGlobalSearch($event)"/>
                <label class="form-check-label" for="flexCheckDefault">Global Search</label>
              </div>
            </div>
            
            <div *ngIf="canAdd" class="col-3">
              <button type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary mb-1 float-right" (click)="addMerchant()"> Add<i class="mdi mdi-plus"></i> </button>
            </div>

            <div class="col-12">
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0" style="width: 100%">
                <thead>
                  <tr>
                    <th>Merchant</th>
                    <th>Name / Location</th>
                    <th class="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let merchant of merchants">

                    <td>{{ merchant.merchantNumber }}</td>
                    <td>{{ merchant.nameLocation }}</td>
                    <td>
                      <button *ngIf="canDelete" type="button" class="btn btn-icon waves-effect waves-light btn-outline-danger fa-pull-right" (click)="determineDeleteDialog(merchant)">
                        <i class="mdi mdi-delete"></i>
                        Delete
                      </button>
                      <button type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary fa-pull-right mx-2" (click)="editMerchant(merchant)">
                        <i class="mdi mdi-pencil-box-outline"></i>
                        {{editView}}
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody *ngIf="merchants?.length == 0">
                  <tr>
                    <td colspan="3" class="no-data-available">No merchants available to display!</td>
                  </tr>
                </tbody>
               
              </table>
            </div>

          </div>
        </div>

      </div>

    </div>

  </div> <!-- end container -->
</div>
